import apiClient from '@shared/utils/axios-instance';

export interface SellerOfferTemplate {
  id: number;
  version: number;
  pdfFileUrl: string;
  createdAt: string;
  uploadedByAdminId: number | null;
}

export const sellerOfferTemplatesApi = {
  list: () =>
    apiClient.get<SellerOfferTemplate[]>('/seller-offer-templates').then((r) => r.data),

  getCurrent: () =>
    apiClient
      .get<SellerOfferTemplate | null>('/seller-offer-templates/current')
      .then((r) => r.data),

  upload: (file: File) => {
    const fd = new FormData();
    fd.append('file', file);
    return apiClient
      .post<SellerOfferTemplate>('/seller-offer-templates', fd)
      .then((r) => r.data);
  },
};
